import { useRef } from 'react';
import { gsap } from 'gsap';
import { useGSAP } from '@gsap/react';
import { usePrefersReducedMotion } from '@/hooks/usePrefersReducedMotion';

const LightRays = () => {
  const containerRef = useRef<SVGSVGElement>(null);
  const prefersReducedMotion = usePrefersReducedMotion();

  useGSAP(
    () => {
      if (prefersReducedMotion) {
        return;
      }

      // Gentle pulsing animation for the light rays
      gsap.to('.light-ray', {
        opacity: 0.5,
        duration: 4,
        stagger: 0.8,
        repeat: -1,
        yoyo: true,
        ease: 'sine.inOut',
      });
    },
    { scope: containerRef, dependencies: [prefersReducedMotion] }
  );

  return (
    <svg
      ref={containerRef}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 1920 1080"
      style={{
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        opacity: 0.6,
      }}
      preserveAspectRatio="xMidYMin slice"
      aria-hidden="true"
    >
      <defs>
        <linearGradient id="ray-gradient" x1="0%" y1="0%" x2="0%" y2="100%">
          <stop offset="0%" stopColor="#0088AA" stopOpacity="0.5" />
          <stop offset="50%" stopColor="#0088AA" stopOpacity="0.25" />
          <stop offset="100%" stopColor="#0088AA" stopOpacity="0" />
        </linearGradient>
      </defs>

      {/* Volumetric light rays from top */}
      <polygon
        className="light-ray"
        points="300,0 350,0 500,1080 400,1080"
        fill="url(#ray-gradient)"
        opacity="0.4"
      />
      <polygon
        className="light-ray"
        points="700,0 780,0 950,1080 820,1080"
        fill="url(#ray-gradient)"
        opacity="0.45"
      />
      <polygon
        className="light-ray"
        points="1200,0 1280,0 1500,1080 1350,1080"
        fill="url(#ray-gradient)"
        opacity="0.35"
      />
      <polygon
        className="light-ray"
        points="1600,0 1650,0 1800,1080 1720,1080"
        fill="url(#ray-gradient)"
        opacity="0.38"
      />
    </svg>
  );
};

export default LightRays;
